.k4okld0 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px;
  background-color: var(--_1qu8za2d);
  border-radius: 8px;
  gap: 12px;
}
.k4okld1 {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.k4okld2 {
  font-weight: 500;
  font-size: 12px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za24);
}
.k4okld3 {
  font-weight: 700;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.02em;
  color: var(--_1qu8za23);
}
.k4okld4 {
  font-weight: 500;
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: -0.01em;
  color: var(--_1qu8za28);
  flex-shrink: 0;
}